import { ReplacementPartType } from '../types/bucketTypes'

export const groupReplacementParts = (
    replacementParts: ReplacementPartType[] | undefined | null
) => {
    if (!Array.isArray(replacementParts) || replacementParts.length === 0) {
        return {};
    }
    let groupedParts = replacementParts.reduce((r: any, a: any) => {
        r[a.type] = r[a.type] || []
        r[a.type].push(a)
        return r
    }, Object.create(null))
    let formattedObject = removeSpaces(groupedParts)
    return formattedObject
}

const removeSpaces = (data: any) => {
    if (!data || typeof data !== 'object') return {};
    let keys = Object.keys(data)
    keys.forEach((key: string) => {
        if (key.includes(' ')) {
            let newKey = key.split(' ').join('_')
            data[newKey] = data[key]
            delete data[key]
        }
    })
    return data
}
